import { z } from "zod";

export const schema = z.object({
    email: z.string().min(1, "forms.general-validation.email_required").email("forms.general-validation.email_invalid"),
});

export type ForgotPasswordFormData = z.infer<typeof schema>;
